module.exports = __webpack_public_path__ + "img/vip-crowd_cclub.74dddb62.webp";